<template>
  <div class="alipayInitPage">
    <XR-head titleText="支付宝" :rightShow="false"></XR-head>    

    <div id="pay-methods-panel" class="pay-methods-panel">
        <div class="wrapper buy-wrapper">
          <mu-row gutter>
            <mu-col width="100" tablet="50" desktop="33" class="login-div">
              <mu-raised-button @click="btnClick" label="支付" class="J-btn-submit btn mj-submit btn-strong btn-larger btn-block"  primary fullWidth />
            </mu-col>
          </mu-row>
        </div>
    </div>
   

    <XR-toast ref="XRtoast"></XR-toast>
  </div>
</template>

<script>
export default {
  data(){
    return {   
      url:'/retail/pay/alipaySend'
    }
  },
  mounted(){
  },
  methods:{
    btnClick(){
      _AP.pay(this.url);
    }    
  }
}
</script>

<style>
.alipayInitPage .btn-block{
  margin: 20px 5%;
  height: 50px;
  width: 90%;
}
</style>



// WEBPACK FOOTER //
// src/pages/retail/pay/alipayInit.vue